import React, { useState } from "react";

const Step3AddressAndContactDetails = ({ formData, handleChange, nextStep, prevStep }) => {
  const [sameAddress, setSameAddress] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSameAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAddress(checked);
    if (checked) {
      handleChange("presentAddress")({ target: { value: formData.permanentAddress } });
    }
  };

  // Validation checks
  const validate = () => {
    let newErrors = {};
    if (!formData.phoneNo1 || !/^\d{10}$/.test(formData.phoneNo1)) {
      newErrors.phoneNo1 = "Phone No. 1 is required and must be 10 digits.";
    }
    if (!formData.emailId || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      newErrors.emailId = "Valid email is required.";
    }
    if (!formData.aadharCardNumber || formData.aadharCardNumber.trim() === "") {
      newErrors.aadharCardNumber = "Aadhar Card Number is required.";
    }
    if (!formData.panNo || formData.panNo.trim() === "") {
      newErrors.panNo = "Pan Card Number is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validate()) {
      nextStep();
    }
  };
  
//style={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}
  return (    
    <div className="container mt-4">
      {/* Address Section */}
      <div className="card mb-4">
        <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
          <span>Address Details</span>
          <span> {formData.fName} {formData.lName} </span>
        </div>
        <div className="card-body row g-3">
          <div className="col-md-6">
            <label>Permanent Address</label>
            <textarea className="form-control" rows="2" value={formData.permanentAddress} maxLength={255}
              onChange={(e) => {
                handleChange("permanentAddress")(e);
                if (sameAddress) {
                  handleChange("presentAddress")({ target: { value: e.target.value } });
                }
              }}
            />
          </div>

          <div className="col-md-6">
            <label>Present Address</label>
            <textarea className="form-control" rows="2" value={formData.presentAddress} maxLength={255} onChange={handleChange("presentAddress")} />
            <div className="form-check mt-2">
              <input className="form-check-input" type="checkbox" checked={sameAddress} onChange={handleSameAddressChange} id="sameAddress" />
              <label className="form-check-label" htmlFor="sameAddress">Same as Permanent Address</label>
            </div>
          </div>

          <div className="col-md-4">
            <label>State</label>
            <input type="text" className="form-control" value={formData.state} onChange={handleChange("state")} />
          </div>

          <div className="col-md-4">
            <label>City</label>
            <input type="text" className="form-control" value={formData.city} onChange={handleChange("city")} />
          </div>

          <div className="col-md-4">
            <label>Pincode</label>
            <input type="text" className="form-control" value={formData.pincode} onChange={handleChange("pincode")} />
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="card mb-4">
        <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
          <span>Contact Details</span>
          <span>{formData.fName} {formData.lName}</span>
        </div>
        <div className="card-body row g-3">
          <div className="col-md-4">
            <label>Contanct No.<span className="text-danger">*</span></label>
            <input type="text" placeholder="Contanct No. " value={formData.phoneNo1}
              onChange={(e) => {
                if (/^\d{0,10}$/.test(e.target.value)) {
                  handleChange("phoneNo1")(e);
                }
              }}
              className="form-control"
            />
            {errors.phoneNo1 && <small className="text-danger">{errors.phoneNo1}</small>}
          </div>

          <div className="col-md-4">
            <label>WhatApp No.</label>
            <input
              type="text" placeholder="WhatApp No. " value={formData.phoneNo2}
              onChange={(e) => {
                if (/^\d{0,10}$/.test(e.target.value)) {
                  handleChange("phoneNo2")(e);
                }
              }}
              className="form-control"
            />
          </div>

          <div className="col-md-4">
            <label> Email <span className="text-danger">*</span> </label>
            <input
              type="email"
              placeholder="Email"
              value={formData.emailId}
              onChange={handleChange("emailId")}
              className="form-control"
            />
            {errors.emailId && <small className="text-danger">{errors.emailId}</small>}
          </div>

          <div className="col-md-4">
            <label>Aadhar Card No. <span className="text-danger">*</span></label>
            <input type="text" placeholder="Aadhar Card" value={formData.aadharCardNumber}
              onChange={(e) => {
                if (/^\d{0,12}$/.test(e.target.value)) {
                  handleChange("aadharCardNumber")(e);
                }
              }}
              maxLength={12}
              className="form-control"
            />

            {errors.aadharCardNumber && (
              <small className="text-danger">{errors.aadharCardNumber}</small>
            )}
          </div>

          <div className="col-md-4">  
            <label>PAN No. <span className="text-danger">*</span></label>
            <input type="text" placeholder="PAN No." value={formData.panNo} maxLength={10} className="form-control"
              onChange={(e) => {
                if (/^[A-Za-z0-9]{0,10}$/.test(e.target.value)) {
                  handleChange("panNo")(e);
                }
              }}
            />
            {errors.panNo && <small className="text-danger">{errors.panNo}</small>}
          </div>

          <div className="col-md-4">
            <label>Driving License No.</label>
            <input type="text" placeholder="Driving License" value={formData.drivingLicNo} maxLength={16} className="form-control"
              onChange={(e) => {
                if (/^[A-Za-z0-9]{0,16}$/.test(e.target.value)) {
                  handleChange("drivingLicNo")(e);
                }
              }}    
            />
          </div>

          <div className="col-md-4">
            <label>Passport No.</label>
            <input type="text" placeholder="Passport No." value={formData.passportNo} onChange={handleChange("passportNo")} className="form-control" />
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="d-flex justify-content-between">
        <button className="btn btn-secondary" onClick={prevStep}> Back </button>
        <button className="btn btn-primary" onClick={handleNext}> Next </button>
      </div>
    </div>
  );
};

export default Step3AddressAndContactDetails;
